//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'FI_C',
  data() {
    return {
      form: {
        weight: '',
      },
      hasScore: false,
      disabled: false,
      num: '',
      num1: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        if (form.weight > 0 && form.weight < 11) {
          self.num = 100 * form.weight
          self.num1 = 4 * form.weight
        } else if (form.weight > 10 && form.weight < 21) {
          self.num = 1000 + 50 * (form.weight - 10)
          self.num1 = 40 + 2 * (form.weight - 10)
        } else if (form.weight > 20) {
          self.num = 1500 + 20 * (form.weight - 20)
          self.num1 = 60 + 1 * (form.weight - 20)
        }
        self.num = self.num.toFixed(0)
        self.num1 = self.num1.toFixed(0)
        self.hasScore = true
        return String(self.num, self.num1)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/FI_C.vue